export default "__VITE_PUBLIC_ASSET__6a995d61__"